// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let UserSession = require("../common/UserSession/UserSession.bs.js");

function FeatureGate$PropertyDetailsGate(props) {
  let children = props.children;
  let __negate = props.negate;
  let negate = __negate !== undefined ? __negate : false;
  let shouldShow = UserSession.useShouldShowPropertyDetails(props.otherAgentId);
  if (shouldShow) {
    if (negate) {
      return null;
    } else {
      return children;
    }
  } else if (negate) {
    return children;
  } else {
    return null;
  }
}

let PropertyDetailsGate = {
  make: FeatureGate$PropertyDetailsGate
};

let propertyDetailsGateJs = FeatureGate$PropertyDetailsGate;

exports.PropertyDetailsGate = PropertyDetailsGate;
exports.propertyDetailsGateJs = propertyDetailsGateJs;
/* UserSession Not a pure module */
